export default __webpack_public_path__ + "static/media/matias-1199x1199.abe95ef1.webp";